import type { CloserLeadFormData } from '@/types'
import { emptyCloserLeadFormData } from '@/utils/closerLeadDraft'

/** Campos exigidos pelo backend (createCloserLeadSchema) e pelo validateRequiredCloserFields. */
export const CLOSER_LEAD_REQUIRED_FIELD_KEYS = ['empresa', 'contato', 'telefone'] as const

export function hasCloserLeadOptionalData(formData: CloserLeadFormData): boolean {
  const defaults = emptyCloserLeadFormData

  if (formData.cargo?.trim()) return true
  if (formData.email?.trim()) return true
  if (formData.site?.trim()) return true
  if (formData.parceiroId) return true
  if (formData.segmento?.trim()) return true
  if (formData.plataforma?.trim()) return true
  if (formData.modelo?.trim() && formData.modelo !== defaults.modelo) return true
  if (formData.faturamento?.trim()) return true
  if (formData.trafego?.trim()) return true
  if (formData.origem?.trim()) return true
  if (formData.problema?.trim()) return true
  if (formData.observacoes?.trim()) return true
  if ((formData.servicos?.length ?? 0) > 0) return true
  if (typeof formData.score === 'number' && formData.score !== defaults.score) return true

  return false
}
